/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

if(document.querySelector(".bo_product_option")){
// Get all elements with class 'bo_product_option'
var boProductOptions = document.querySelectorAll('.bo_product_option');

// Add click event listener to each element
boProductOptions.forEach(function(option) {
  option.addEventListener('click', function() {
    // Remove 'is-selected' class from siblings
    var siblings = this.parentNode.children;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== this) {
        siblings[i].classList.remove('is-selected');
      }
    }

    // Add 'is-selected' class to the clicked element
    this.classList.add('is-selected');

    // Find the corresponding element with data-value and trigger click event
    var dataValue = this.getAttribute('data-value');
    var popoverValue = document.querySelector(".Popover__Value[data-value='" + dataValue + "']");
    if (popoverValue) {
      popoverValue.click();
    }
  });
});
}
/*
$('.bo_product_option').on('click', function(){
  $(this).siblings().removeClass('is-selected');
  $(this).addClass('is-selected');
  $(".Popover__Value[data-value='" + $(this).data('value') + "']").trigger('click');
});
*/
